export interface IState {
  departmentList: any;
  countryList: any;
  stateList: any;
  cityList: any;
  employeeList: any;
  singleEmployeeList: any;
  positionsList: any;
  employeeCount: number;
  singleEmployeeDetails: any;
  uniqueLocation: any;
  employeeLastId: any;
  carrierList: any;
  employeeDependentList: any;
  ptoHistoryList: any;
  ptoTabList: any;
}

type Action = any;

export const hrModuleReducer = (
  state: IState = {
    departmentList: [],
    countryList: [],
    stateList: [],
    cityList: [],
    employeeList: [],
    singleEmployeeList: [],
    positionsList: [],
    employeeCount: 0,
    singleEmployeeDetails: {},
    uniqueLocation: [],
    employeeLastId: null,
    carrierList: [],
    employeeDependentList: [],
    ptoHistoryList: [],
    ptoTabList: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_DEPARTMENT":
      return {
        ...state,
        departmentList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.departmentList, ...action?.payload?.data],
      };
    case "UPDATE_DEPARTMENT":
      return {
        ...state,
        departmentList: state?.departmentList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };

    case "DELETE_DEPARTMENT":
      return {
        ...state,
        departmentList: state?.departmentList?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_DEPARTMENT":
      return {
        ...state,
        departmentList: state?.departmentList?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_COUNTRY":
      return {
        ...state,
        countryList: action?.payload?.data,
      };
    case "GET_STATES":
      return {
        ...state,
        stateList: action?.payload?.data,
      };
    case "GET_CITIES":
      return {
        ...state,
        cityList: action?.payload?.data,
      };
    case "CLEAR_STATES":
      return {
        ...state,
        stateList: [],
      };
    case "CLEAR_CITIES":
      return {
        ...state,
        cityList: [],
      };
    case "GET_EMPLOYEE":
      return {
        ...state,
        employeeList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.employeeList, ...action?.payload?.data],
        employeeCount: action?.payload?.count,
      };
    case "GET_EMPLOYEE_DEPEnDENT":
      return {
        ...state,
        employeeDependentList:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.employeeDependentList, ...action?.payload?.data],
      };

    case "GET_POSITIONS":
      return {
        ...state,
        positionsList: action?.payload?.data,
      };
    case "GET_SINGLE_EMPLOYEE":
      return {
        ...state,
        singleEmployeeDetails: action?.payload?.data,
      };

    case "GET_UNIQE_LOCATION":
      return {
        ...state,
        uniqueLocation: action?.payload,
      };

    case "GET_SINGLE_EMPLOYEE_ARRAY":
      return {
        ...state,
        singleEmployeeList: action.payload,
      };
    case "GET_CARRIER":
      return {
        ...state,
        carrierList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.carrierList, ...action?.payload?.data],
      };

    case "UPDATE_PHONE_CARRIER":
      return {
        ...state,
        carrierList: state?.carrierList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };

    case "DELETE_PHONE_CARRIER":
      return {
        ...state,
        carrierList: state?.carrierList?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_PHONE_CARRIER":
      return {
        ...state,
        carrierList: state?.carrierList?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_EMPLOYEE_ID":
      return {
        ...state,
        employeeLastId: Number(action?.payload) + 1,
      };
    case "DELETE_EMPLOYE":
      if (action?.payload.isDelete) {
        return {
          ...state,
          employeeList: state?.employeeList?.filter((elem: any) => elem?._id != action?.payload?.id),
        };
      } else {
        return {
          ...state,
          singleEmployeeList: state?.singleEmployeeList?.map((elem: any) => {
            if (elem?._id == action?.payload?.id) {
              return { ...elem, is_active: 0 };
            }
            return elem;
          }),
        };
      }
    case "RESTORE_EMPLOYE":
      if (action?.payload.isRestore) {
        return {
          ...state,
          employeeList: state?.employeeList?.filter((elem: any) => elem?._id != action?.payload?.id),
        };
      } else {
        return {
          ...state,
          singleEmployeeList: state?.singleEmployeeList?.map((elem: any) => {
            if (elem?._id == action?.payload?.id) {
              return { ...elem, is_active: 1 };
            }
            return elem;
          }),
        };
      }
    case "UPDTAE_EMPLOYEE_LOGIN":
      return {
        ...state,
        singleEmployeeList: state?.singleEmployeeList?.map((elem: any) => {
          return { ...elem, allow_login: action?.payload };
        }),
      };
    case "GET_PTO_HISTORY_DATA":
      return {
        ...state,
        ptoHistoryList:
          action?.payload?.page == 1 || !action?.payload?.page
            ? action?.payload?.data
            : [...state?.ptoHistoryList, ...action?.payload?.data],
      };
    case "GET_PTO_TABS_DATA":
      return {
        ...state,
        ptoTabList: action?.payload,
      };

    default:
      return state;
  }
};
